import React from 'react';
import { Typography, Grid } from '@material-ui/core';
import { TemplateInfoSectionProps } from 'typings';
import useTemplateStyles from '../../styles/templateStyle';

const TemplateInfoSection: React.FC<TemplateInfoSectionProps> = (templateInfoProps) => {
  const { isMobile, templateTitle, authorLabel, author, description, publishedDateLabel, publishedDate } = templateInfoProps;
  const classes = useTemplateStyles();
  const alignment = isMobile ? 'center' : 'left';

  return (
    <Grid item xs={12} md={8}>
      <div>
        <Typography variant='h4' align={alignment} className={classes.marginBottom}>
          {templateTitle}
        </Typography>
        <Typography variant='body1' align={alignment} color='primary' className={classes.marginBottom}>
          {authorLabel} {author}
        </Typography>
        <Typography variant='body1' align={alignment} className={classes.marginBottom}>
          {description}
        </Typography>
        <div className={classes.flexSpaceBetween}>
          <Typography variant='body1'>
            {publishedDateLabel} {new Date(publishedDate).toLocaleDateString()}
          </Typography>
        </div>
      </div>
    </Grid>
  );
};

export default TemplateInfoSection;
